import React from 'react';
import StatusPill from './StatusPill';

// Back-compat shim: every existing call site still works, but renders the
// new pill. Keeps a single styling source of truth.
export default function ContainerBadge({ status }) {
  return <StatusPill status={status} />;
}
